module.exports = __webpack_public_path__ + "img/checklist_icon_sl.b65d3f2e.png";